<template>
     
  <div class="px-2" style="{backgruond-color:white}">
    <HeaderBar/>
    <!-- search input -->
    <v-offline 
    online-class="online"
    offline-class="offline"
    @detected-condition="onConnectionChange">
        <template v-if="online">
        <div class="flex w-full h-full justify-center items-center text-6xl">
            
        </div>
        </template>
        <template v-if="!online">
        <div class="flex w-full h-full justify-center items-center text-6xl">
        Sin Conexión
        </div>
        </template>
    </v-offline>
    <div class="d-flex justify-content-center mt-1 headTitle mb-2">Animales</div>
    <div class="d-flex justify-content-center mt-1 headTitle mb-2">{{fincaName}}</div>
    <!-- table -->
    <vue-good-table :columns="columns" :rows="rows" :rtl="direction"  styleClass="vgt-table bordered"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" 
      
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
        mode:'records',
        nextLabel: ' Siguiente > ',
        prevLabel: ' < Anterior ',
        perPageDropdown: [10, 20,50,100],
        dropdownAllowAll: false,
        rowsPerPageLabel: 'Animales por página',
        ofLabel: 'de',
        position: 'bottom',
        pageLabel: 'página',
      }"
      
      :sort-options="{
        enabled: true,
      }"

      @on-row-click="showModal"
    >
      <template slot="table-row" slot-scope="props">

        <!-- Column: Name -->
        <span v-if="props.column.field === 'sex'" class="text-center">
          <span v-if="props.row.sex===false" class="text-center">M</span>
          <span v-if="props.row.sex===true" class="text-center">H</span>
          
        </span>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ props.row.status }}
          </b-badge>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <!-- <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Mostrando 1 de
            </span>
            <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
              @input="(value) => props.perPageChanged({ currentPerPage: value })" />
            <span class="text-nowrap"> of {{ props.total }} registros </span>
          </div>
        </div>
      </template> -->
    </vue-good-table>
    <div>
      <a class="btn btn-danger mt-2" @click="navigateTo('/advanceHome/AnimalsStatus')">Ver animales inactivos</a>
    </div>
    <div class="d-flex justify-content-center  mt-2 mb-1"><b-button @click="exportCSV" class="bg-primary w-50"> Exportar CSV</b-button></div>
    <b-modal centered v-model="modalShow" hide-footer hide-header>
      <div v-if="modalCase == 0">
        <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2 ">Animales


        </div>
        <div class="linkTitle mt-5" @click="modalCase = 1">Datos Generales</div>
        <div class="linkTitle mt-2" @click="modalCase = 2">Evolución de Peso</div>
        <div class="linkTitle mt-2" @click="modalCase = 3">Datos Sanitarios</div>
        <div class="linkTitle mt-2" @click="modalCase = 4">Datos Reproductivos</div>
        <div class="linkTitle mt-2 mb-5" @click="modalCase = 5">Datos Productivos</div>

        <div class="text-center"><b-button class="btn-danger mt-2 mb-2">Eliminar</b-button></div>
      </div>


      <div v-if="modalCase == 1">
        <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Generales</div>
        <div class=" d-flex justify-content-end  border-bottom">
          <feather-icon @click="editBtn()" icon="Edit2Icon" size="20" v-if="!isAdmin()"/>
          <!-- <feather-icon class="" @click="modalTrashShow = !modalTrashShow" icon="TrashIcon" size="20" /> -->
        </div>
        <div class="d-flex align-items-center justify-content-center pt-2">
          <b-img :src="animalData.image_url" width="200"/>
        </div>
        <div  class="ml-2 mt-2" style="text-wrap:balance;" >
          <p class="editModal"> {{animalData.number}} - {{animalData.name}}</p>
        </div>
            
        <div class="d-flex justify-content-between mt-3 ">
          
          <div class="ml-2">Peso <p class="editModal">{{animalData.weight}}</p> </div> 
          <div class="mr-5 pr-3">Edad <br /><p class="editModal"> {{animalData.age}} </p></div>
        </div>
       
          
          <div class="ml-2">Madre <p class="editModal">{{Mother}}</p> </div> 
          <div class="ml-2">Padre <br /><p class="editModal"> {{Father}} </p></div>
        
         <div class="mt-1 ml-2">Sexo <p v-if="animalData.sex===false" class="editModal"> Macho</p> <p v-if="animalData.sex===true" class="editModal"> Hembra</p></div>
         <!-- <div class="d-flex justify-content-center mb-5 mt-3">
          <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img>
         </div> -->
      </div>
        
         <!--////////////// -->
         <div v-if="modalCase == 2">
        <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2">Evolución de Peso</div>
        <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
        <!-- <div class=" d-flex justify-content-end  border-bottom">
          <feather-icon  icon="PlusIcon" size="20" />
        </div> -->
        <div class="d-flex justify-content-between mt-3 ">
          <WheighinsLineChartVue

            :data="weighinsData"
            :options="chartOptions"
          />
        </div>
        <div class="d-flex justify-content-between mt-1">
          <div class=" ml-1">Ganancia de peso diaria <p class="editModal">{{dayliWeight}} g/d</p></div>
          <div class=" ml-1">Dias transcurridos <p class="editModal">{{daysWeight}} </p></div>

        </div>
      </div>
        <!--////////////// -->
       <div v-if="modalCase == 3">
        <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Sanitarios</div>
        <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
        <!-- <div class=" d-flex justify-content-end  border-bottom">
          <feather-icon @click="modalCase=7" icon="Edit2Icon" size="20" />
          <feather-icon class="" @click="modalTrashShow = !modalTrashShow" icon="TrashIcon" size="20" />
        </div> -->
        <div class="d-flex justify-content-between mt-3 ">
          <div class="ml-1">Vacunas <p class="editModal"><a  @click="navigateTo('/basicHome/Animals/Vaccines/'+currAnimal)">{{ vaccinations }}</a></p> </div> 
          <div class="mr-3">Desparacitaciones <p class="editModal"><a  @click="navigateTo('/basicHome/Animals/Dewormings/'+currAnimal)">{{dewormings}}</a></p></div>
        </div>
        <div class="d-flex justify-content-between mt-1">
          <div class=" ml-1">Tratamientos <p class="editModal"><a  @click="navigateTo('/basicHome/Animals/Treathments/'+currAnimal)">{{treathments}}</a></p></div>
           <div class=" mr-3">Alertas <p class="editModal"><a  @click="navigateTo('/basicHome/Animals/Alerts/'+currAnimal)">{{ alerts }}</a></p></div>
        </div>
         <!-- <div class="d-flex justify-content-center mb-5 mt-3">
          <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img>
         </div> -->
      </div>
      <!--////////////// -->
        <div v-if="modalCase==7">
          <div class="d-flex justify-content-end  ">
            <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
          </div>
          <div v-if="!online" class="text-center">
            <b-img width="100px" 
            src="@/assets/images/ganImage/icons/offline.png"
            />
            <p><strong>Sin Conexión</strong></p>
          </div>
        </div>
        <!--////////////// -->
        <div v-if="modalCase == 4">
          <div class="d-flex justify-content-end  ">
            <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
          </div>
          <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Reproductivos</div>
          <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
            <div class="d-flex justify-content-between mt-3 " v-if="animalData.sex==true">
              <!-- <div class="ml-2">Reproduccion <p class="editModal"><a @click="navigateTo('/basicHome/AnimalsReproductive/'+currAnimal+'/8')">{{reproductive}}</a></p> </div> --> 
              <div class="ml-2">Partos <p class="editModal"><a @click="navigateTo('/basicHome/AnimalsReproductive/'+currAnimal+'/4')">{{parts}}</a></p></div>
            </div>
            <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==true">
              <div class=" ml-2">Abortos <p class="editModal"><a  @click="navigateTo('/basicHome/AnimalsReproductive/'+currAnimal+'/5')">{{abortions}}</a></p></div>
              <div class=" mr-5">Palpaciones <p class="editModal"><a @click="navigateTo('/basicHome/AnimalsReproductive/'+currAnimal+'/6')">{{palpations}}</a></p></div>
            </div>
            <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==true">
              <div class=" ml-2">Crías <p class="editModal"><a @click="navigateTo('/basicHome/AnimalsChilds/'+currAnimal)">{{childs}}</a></p></div>
            </div>
            <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==true">
              <div class=" ml-2">Edad Primer Servicio <p class="editModal">{{firstServiceAge}}</p></div>
              <div class=" ml-2">Edad Primer Parto <p class="editModal">{{firstBirthAge}}</p></div>
            </div>
            <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==true">
              <div class=" ml-2">Intervalo Entre Partos  <p class="editModal">{{intervalBetweenBirths}}</p></div>
            </div>
            <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==false">
              <div class=" ml-2">Andrología <p class="editModal"><a @click="navigateTo('/basicHome/AnimalsReproductive/'+currAnimal+'/7')">{{condition}}</a></p></div>
            </div>
            <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==false">
              <div class=" ml-2">Crías<p class="editModal"><a @click="navigateTo('/basicHome/AnimalsChilds/'+currAnimal)">{{childs}}</a></p></div>
            </div>
        </div>
      <!--////////////// -->
      <div v-if="modalCase == 5">
        <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Productivos</div>
        <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
        <!-- <div class=" d-flex justify-content-end  border-bottom">
          <feather-icon  icon="PlusIcon" size="20" />
        </div> -->
        <div class="d-flex justify-content-between mt-1">
          <div class=" ml-1" v-if="animalData.birthdate">Peso al nacer <p class="editModal">{{birthWeight}} </p></div>
          <div class=" ml-1">Peso a los 8 meses <p class="editModal">{{weightAt8Months}} </p></div>
        </div>
        <div class="d-flex justify-content-between mt-1">
          <div class=" ml-1">Peso a los 18 meses <p class="editModal">{{weightAt18Months}} </p></div>
          <div class=" ml-1">Peso de venta <p class="editModal">{{saleWeight}} </p></div>
        </div>
        <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==true">
          <div class=" ml-1">Peso de Leche <p class="editModal">{{lastMilk}} </p></div>
        </div>
        <div class="d-flex justify-content-between mt-1">
          <div class=" ml-1"><small>Datos aproximados, si el animal no cumple la edad estimada se coloca el último pesaje.</small></div>
        </div>
      </div>
        <div v-if="modalCase==6">
         <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Reproduccion</div>
        <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div> 
          <div class="d-flex justify-content-center mt-2" v-if="animalData.sex=='true'">
            <b-form-group class="w-25" label="Reproduccion" label-for="reproduction">
                <b-form-input id="reproduction"/>
            </b-form-group>
            <b-form-group class="w-75 ml-1" label="Partos" label-for="part">
                <b-form-input id="part" />sss
            </b-form-group>
          </div>
          <div class="d-flex justify-content-center mt-1" v-if="animalData.sex=='true'">
            <b-form-group class="w-50" label="Abortos" label-for="abortion">
                <b-form-input id="abortion" />
            </b-form-group>
             <b-form-group class="w-50" label="Palpaciones" label-for="palpation">
                <b-form-input id="palpation" />
            </b-form-group>
          </div>

          <div class="d-flex justify-content-center mt-1" v-if="animalData.sex=='false'">
             <b-form-group class="w-50" label="Andrologia" label-for="palpation">
                <b-form-input id="palpation" />
            </b-form-group>
          </div>
        <div class="d-flex justify-content-center  mt-2">
         <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img></div>
         
         <div class="d-flex justify-content-center  mt-2 mb-1"><b-button class="bg-primary w-50"> Guardar</b-button></div>
        
        </div>
      <b-modal class="modal-lg" centered v-model="modalTrashShow" hide-footer hide-header>
        <div class="d-flex  align-items-end justify-content-end">
          <feather-icon @click="modalTrashShow = !modalTrashShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex flex-column align-items-center justify-content-center">
          <span class="deleteModal mt-2"> ¿Desea eliminar? </span>
          <b-button class="bg-deleteButton mt-2 mb-2">Eliminar</b-button>
        </div>
      </b-modal>

    </b-modal>
    <AddButton preTitle="Agregar Animal" goTo="advance-animalhome" v-if="!isAdmin()"/>
    <ControlMenu />
  </div>
</template>

<script>
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import AddButton from '@/components/AddButton.vue'

import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BAvatar, BBadge, BPagination, BFormGroup, BFormSelect,BFormFile, BFormCheckbox, BDropdown, BDropdownItem, BRow, BCol, BLink, BCardBody, BCard, BButton, BForm, BFormInput, BInputGroup, BImg, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import PlusButton2 from '@/components/PlusButton2.vue'
import store from '@/store/index'
import WheighinsLineChartVue from '../DataLog/Animal/WheighinsLineChart.vue';
import { VOffline } from 'v-offline';
import imageFile from "@/assets/images/ganImage/image 177.svg"
import axios from "axios";

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BInputGroup,
    BCardBody,
    BCard,
    VueGoodTable,
    vSelect,
    PlusButton2,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormFile,
    BDropdown,
    BDropdownItem,
    ControlMenu,
    HeaderBar,
    WheighinsLineChartVue,
    AddButton,
    VOffline
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    return {
      fincaName:localStorage.getItem('currentFarmName'),
      online:false,
      fileU:null,
      imgWidth:null,
      featured:imageFile,
      currAmimal:0,
      pageLength: 10,
      dir: false,
      status1: null,
      status2: null,
      modalShow: false,
      Mother:null,
      currentDate:today,
      Father:null,
      modalCase: 0,
      editShow:false,
      modalTrashShow:false,
      findParents:null,
      straws:null,
      columns: [
        {
          label:  'CODIGO',
          field:  'number',
          type:   'string'
        },  
        {
          label:  'ANIMAL',
          field:  'name',
          type:   'string'
        },
        {
          label:  'SEXO',
          field:  'sex',
          type:   'boolean'
        },
        {
          label:  'PESO',
          field:  'weight',
          type:   'number'
        },
        {
          label:  'EDAD',
          field:  'age',
          type:   'number'
        },

      ],
      rows: [],
      rowsExport: [],
      animalData:[],
      animal:{
        name:"",
        number:"",
        sirigapp:"",
        weight:0,
        age:0,
        sex:false,
        mother:"",
        dad:"",
        image_url:"",
        image1:"",
        image2:"",
        image3:"",
        birthdate:"",
        buy_date:null,
        farm_id:localStorage.getItem('currentFarm'),
        state:1,
        price:0,
        batch_id:'Otro'
      },
      weighinsData:{
        labels:[],
        datasets: [
          { label:'Evolución de peso',
            backgroundColor: '#5E8F23',
            data:[]
          }
        ]
      },
      chartOptions:{
        responsive: true,
        maintainAspectRatio: false,
        backgroundColor: false,
        hover: {
          mode: 'label',
        },
        layout: {
          padding: {
            top: 0,
            bottom: 0,
            left: 0,
            right:20
          },
        },
        
        legend: {
          position: 'top',
          align: 'start',
          labels: {
            usePointStyle: true,
            padding: 25,
            boxWidth: 9,
          },
        },
      },
      weighins:{
        observations:'',
        animal_id:this.currAmimal,
        weight:0,
        date:''
      },
      dayliWeight:0,
      daysWeight:0,
      searchTerm: '',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      vaccionations:0,
      dewormings:0,
      treathments:0,
      alerts:0,
      childs:0,
      reproductive:0,
      parts:0,
      abortions:0,
      palpations:0,
      andrology:0,
      intervalBetweenBirths:0,
      firstServiceAge:0,
      firstBirthAge:0,
      currentBornDate:null,
      condition:'No realizado',
      currentLevelAccess: localStorage.getItem("currentLevelAccess"),
      birthWeight:0,
      saleWeight:0,
      weightAt8Months:0,
      weightAt18Months:0,
      lastMilk:0,
    }
  },
  computed: {
    
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  methods:{
    isAdmin() {
            return this.currentLevelAccess === "Visualizador";
    },
    editBtn() {
      let id = this.currAnimal;
      this.$router.push('/advanceHome/farm/editanimals/' + id);
      console.log(id);
    },
    async fetchAnimals(config){
      if(this.online){
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/animals?recperpage=all&state=1&farm_id="+farmId, config)
        .then(response => response.json())
        .then(result => {
          console.log('animal s')
            console.log(result);
            this.rows = result.animals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age}});
            //this.rows = result.animals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.birthdate?this.calculateMonthsDifference(item.birthdate,this.currentDate):item.age}});
            //this.rowsExport = result.animals.map(item => {return {Numero:item.number,Nombre:item.name,Sexo: item.sex=true ?'Macho':'Hembra',Peso:item.weight, Edad:item.age, Precio: item.price, Madre:item.mother, Padre:item.father, Raza:item.batch_id}});
            console.log(this.rows);
        })
      }else{
        let localanimals= JSON.parse(localStorage.getItem('animalsTemp'));
        if(localanimals.length>0){
          this.rows=localanimals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age}});
        }
        
      }
    },
    async fetchStraws(config){
      if(this.online){
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/straws?recperpage=all&farm_id="+farmId, config)
        .then(response => response.json())
        .then(result => {
            console.log('straws');
            console.log(result.straws);
            this.straws= result.straws;
          })
      }
    },
    async fetchAnimalsExport(config){
      if(this.online){
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/AnimalsInventory?recperpage=all&state=1&farm_id="+farmId, config)
        .then(response => response.json())
        .then(result => {
            console.log(result.AnimalsInventory);
            this.findParents= result.AnimalsInventory;
            //this.rows = result.AnimalsInventory.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age}});
            this.rowsExport = result.AnimalsInventory.map(item => {return {Numero:item.number,Nombre:item.name,Sexo: item.sex=true ?'Macho':'Hembra',Peso:item.weight, Edad:item.age, Precio: item.price, Madre:item.mother_number ? item.mother_number + ' - ' + item.mother_name : item.mother, Padre:item.father_number ? item.father_number + ' - ' + item.father_name : item.father, Raza:item.batch_id,Fecha_Compra:item.buy_date, }});
            //console.log(this.animals);
        })
      }else{
        let localanimals= JSON.parse(localStorage.getItem('animalsTemp'));
        if(localanimals.length>0){
          this.rows=localanimals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age}});
        }
        
      }
    },

    async fetchAnimalData(config){
      let self=this;
      let id= self.currAnimal;
      console.log("curr",self.currAnimal);
      let getParents= this.findParents.filter(item=>item.id==id);
      
      console.log(getParents);
      await fetch(this.$apiUrl+"view/animals/"+id, config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            this.currAnimalSex=result.sex;
            this.animalData = result.animals;
            this.animal= result.animals;
            console.log(this.animalData.father);
            let getStraw = this.straws.filter(item=>item.id==this.animalData.father);
            console.log(getStraw);
            console.log('straw size: '+getStraw.length);
            this.currentBornDate=result.animals.birthdate;
            // Lógica para el padre
            if (getParents.length > 0) {
                if (getParents[0].father_number === null || getParents[0].father_number === "") {
                    if (Number.isInteger(parseInt(this.animalData.father,10))) {
                        // Si no hay padre en getParents, buscar en straws
                        if (getStraw.length > 0) {
                            this.Father = getStraw[0].code + ' - ' + getStraw[0].name + ' / ' + getStraw[0].race;
                        } else {
                            // Si no hay en straws, asignar el valor de father como un entero
                            this.Father = this.animalData.father; // Aquí se asigna el identificador directamente
                        }
                    } else {
                        this.Father = getParents[0].father;
                    }
                } else {
                    this.Father = getParents[0].father_number + ' - ' + getParents[0].father_name;
                }
            } else {
                // Si no hay padres en getParents, buscar en straws
                if (getStraw.length > 0) {
                    this.Father = getStraw[0].code + ' - ' + getStraw[0].name;
                } else {
                    // Si no hay en straws, asignar el valor de father como un entero
                    this.Father = this.animalData.father; // Aquí se asigna el identificador directamente
                }
            }

            // Lógica para la madre
            if (getParents.length > 0) {
                this.Mother = (getParents[0].mother_number === null || getParents[0].mother_number === "")
                    ? getParents[0].mother 
                    : getParents[0].mother_number + ' - ' + getParents[0].mother_name;
            } else {
                // Si no hay padres en getParents, puedes asignar un valor por defecto o dejarlo vacío
                this.Mother = ''; // O el valor que desees asignar
            }
        })
    },

    async fetchAnimalWheihins(config){
      let id= this.currAnimal;
        fetch(this.$apiUrl+"list/weighins?animal_id="+id+"&recperpage=all&order=date&ordertype=ASC", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            this.weighinsData.labels= result.weighins.map(item => {return this.formatDate(item.date)});
            this.weighinsData.datasets[0].data = result.weighins.map(item => {return item.weight});
            const lastWeight =  result.weighins[ result.weighins.length - 1];
            const previousWeight =  result.weighins[ result.weighins.length - 2];
            if (previousWeight) {
                // Calcular la ganancia de peso
                this.dayliWeight = parseFloat(lastWeight.weight) - parseFloat(previousWeight.weight);
                // Calcular la diferencia de días
                const lastDate = new Date(lastWeight.date);
                const previousDate = new Date(previousWeight.date);
                this.daysWeight = Math.ceil((lastDate - previousDate) / (1000 * 60 * 60 * 24)); // Diferencia en días
                this.dayliWeight= ((this.dayliWeight/this.daysWeight)*1000).toFixed(2);
                this.calculateWeights( result.weighins, this.currentBornDate);
           } else {
                console.log("No hay suficientes datos para calcular la ganancia de peso y la diferencia de días.");
            }
            console.log(this.weighinsData);
        })
    },
    async fetchAnimalMilks(config){
      let id= this.currAnimal;
        fetch(this.$apiUrl+"list/milk_records?animal_id="+id+"&recperpage=all&order=date&ordertype=ASC", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            if(result.milk_records.length>0){
              const lastMilk =  result.milk_records[ result.milk_records.length - 1];
              this.lastMilk= lastMilk.liters;
            }else{
              this.lastMilk=0;
            }
            //this.weighinsData.labels= result.weighins.map(item => {return item.date});
            //this.weighinsData.datasets[0].data = result.weighins.map(item => {return item.weight});

            
        })
    },
    async fetchAnimalVacinations(config){
      let id= this.currAnimal;
      let self=this;
      this.vaccinations=0;
      let vacs=[];
        fetch(this.$apiUrl+"list/VaccinationsByAnimals?animal_id="+id+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            result.VaccinationsByAnimals.map(item => {
              if(item.animal_id==id){
                
                vacs.push(item)
                console.log(vacs)
                this.vaccinations=(parseInt(vacs.length))
                console.log(this.vaccinations)
              }
            })

        })
    },
    async fetchAnimalDewormings(config){
      let id= this.currAnimal;
      let self=this;
      this.dewormings=0;
      let vacs=[];
        fetch(this.$apiUrl+"list/DemormerbyAnimals?animal_id="+id+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            result.DemormerbyAnimals.map(item => {
              if(item.animal_id==id){
                
                vacs.push(item)
                console.log(vacs)
                this.dewormings=(parseInt(vacs.length))
                console.log(this.dewormings)
              }
            })

        })
    },
    async fetchAnimalTreathments(config){
      let id= this.currAnimal;
      let self=this;
      this.treathments=0;
      let vacs=[];
        fetch(this.$apiUrl+"list/TreathmentsByAnimals?animal_id="+id+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            result.TreathmentsByAnimals.map(item => {
              if(item.animal_id==id){
                
                vacs.push(item)
                console.log(vacs)
                this.treathments=(parseInt(vacs.length))
                console.log(this.treathments)
              }
            })

        })
    },
    uploadImage(){
      this.$refs['FileUpload'].$el.click();
    },
    calculateWeights(records, birthDate) {
      this.birthWeight=0;
      this.weightAt8Months=0;
      this.weightAt18Months=0;
      this.saleWeight=0;
      const result = {
          birthWeight: null,
          weightAt8Months: "Aún no tiene 8 meses",
          weightAt18Months: "Aún no tiene 18 meses",
          saleWeight: null
      };

      // Peso al nacimiento
      result.birthWeight = parseFloat(records[0].weight); // Asumiendo que el primer registro es el del nacimiento

      // Fechas de 8 y 18 meses
      const eightMonthsDate = new Date(birthDate);
      eightMonthsDate.setMonth(eightMonthsDate.getMonth() + 9);

      const eighteenMonthsDate = new Date(birthDate);
      eighteenMonthsDate.setMonth(eighteenMonthsDate.getMonth() + 18);

      // Filtrar registros para encontrar pesos a los 8 y 18 meses
      let weightAt8Months = null;
      let weightAt18Months = null;

      records.forEach(record => {
          const recordDate = new Date(record.date);
          
          // Peso a los 8 meses
          if (recordDate <= eightMonthsDate) {
              weightAt8Months = parseFloat(record.weight);
          }

          // Peso a los 18 meses
          if (recordDate <= eighteenMonthsDate) {
              weightAt18Months = parseFloat(record.weight);
          }
      });

      // Asignar pesos a los 8 y 18 meses
      if (weightAt8Months !== null) {
          result.weightAt8Months = weightAt8Months;
      }

      if (weightAt18Months !== null) {
          result.weightAt18Months = weightAt18Months;
      }

      

      // Peso de venta (último registro)
      result.saleWeight = parseFloat(records[records.length - 1].weight);
      this.birthWeight=parseFloat(records[0].weight);
      this.weightAt8Months=weightAt8Months;
      this.weightAt18Months=weightAt18Months;
      this.saleWeight=parseFloat(records[records.length - 1].weight);
      console.log(result);
      return result;
    },
    formatDate(date){
      const fecha = new Date(date);
      const dia = String(fecha.getDate()).padStart(2, '0');
      const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses son 0-indexados
      const anio = fecha.getFullYear();
      return  `${anio}-${mes}-${dia}`
    },
    calculateReproductive(records, birthDate) {
      let firstServiceAge = null;
      let firstBirthAge = null;
      let intervalBetweenBirths = null;
      console.log(birthDate);

      // Filtrar registros de servicios y partos
      const services = records.filter(record => record.type_id === 9);
      const births = records.filter(record => record.type_id === 4);
      console.log(services);
      console.log(births);

      // Calcular la edad al primer servicio
      if (services.length > 0) {
          const firstServiceDate = new Date(services[0].date);
          //if (firstServiceDate >= birthDate) {
              firstServiceAge = this.calculateMonthsDifference(birthDate, firstServiceDate);
              console.log(firstServiceAge);
              this.firstServiceAge = firstServiceAge;
          //}
      }

      // Calcular la edad al primer parto
      if (births.length > 0) {
          const firstBirthDate = new Date(births[0].date);
          //if (firstBirthDate >= birthDate) {
              firstBirthAge = this.calculateMonthsDifference(birthDate, firstBirthDate);
              console.log(firstBirthAge);
              this.firstBirthAge = firstBirthAge;
          //}
      }

      // Calcular el intervalo entre partos
      if (births.length > 1) {
          const lastBirthDate = new Date(births[births.length - 1].date);
          const previousBirthDate = new Date(births[births.length - 2].date);
          if (lastBirthDate >= previousBirthDate) {
              intervalBetweenBirths = this.calculateMonthsDifference(previousBirthDate, lastBirthDate);
              this.intervalBetweenBirths = intervalBetweenBirths;
          }
      } else {
          this.intervalBetweenBirths = 'N/A';
      }
      console.log(firstServiceAge,
          firstBirthAge,
          intervalBetweenBirths);
      /*return {
          firstServiceAge,
          firstBirthAge,
          intervalBetweenBirths
      };*/
    },

    calculateMonthsDifference(startDate, endDate) {
      let initDate = new Date(startDate);
      let finalDate= new Date(endDate)
      if (!(initDate instanceof Date) || !(finalDate instanceof Date)) {
          throw new TypeError("startDate and endDate must be Date objects");
      }
      let monthsDifference = (finalDate.getFullYear() - initDate.getFullYear()) * 12;
      monthsDifference -= initDate.getMonth();
      monthsDifference += finalDate.getMonth();
      // Si el día del endDate es menor que el día del startDate, restar un mes
      if (finalDate.getDate() < initDate.getDate()) {
        monthsDifference--;
      }

      return monthsDifference;
    },

    async fetchAnimalReproductive(config){
      let id= this.currAnimal;
      let self=this;
      this.reproductive=0;
      this.parts=0;
      this.abortions=0;
      this.palpations=0;
      this.andrology=0;
      this.condition='No realizado';
      let arrparts=[];
      let arrabortions=[];
      let arrpalpations=[];
      let arrreproductive=[];
        fetch(this.$apiUrl+"list/ReproductiveRecordsByAnimals?animalid="+id+"&recperpage=all&order=date&ordertype=ASC", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            result.ReproductiveRecordsByAnimals.map(item => {
              //Delivery
              if(item.type_id==4){
                arrparts.push(item)
                console.log(arrparts)
                this.parts=(parseInt(arrparts.length))
                console.log(this.parts)
              }else if(item.type_id==5){
                arrabortions.push(item)
                console.log(arrabortions)
                this.abortions=(parseInt(arrabortions.length))
                console.log(this.abortions)
              }else if(item.type_id==6){
                arrpalpations.push(item)
                console.log(arrpalpations)
                this.palpations=(parseInt(arrpalpations.length))
                this.reproductive=(parseInt(arrpalpations.length))
                
                console.log(this.palpations)
              } else if(this.animalData.sex==false && item.type_id==7){
                arrreproductive.push(item)
                console.log(arrreproductive)
                this.andrology=(parseInt(arrreproductive.length))
                this.condition=arrreproductive[arrreproductive.length-1].condition_text;
                console.log(this.reproductive)
              }
            })

            this.calculateReproductive(result.ReproductiveRecordsByAnimals, this.currentBornDate)
        })
    },
    async fetchChilds(config){
      let id= this.currAnimal;
      let self=this;
      this.childs=0;

      if(this.currAnimalSex===true){
        fetch(this.$apiUrl+"list/animals?mother="+id+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
          console.log('childs')
          console.log(result);
          this.childs=(parseInt(result.animals.length))
        })
      }else{
        fetch(this.$apiUrl+"list/animals?father="+id+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
          console.log('childs')
          console.log(result);
          this.childs=(parseInt(result.animals.length))
        })
      }0
        
    },
    updateAnimal(){
      const token = localStorage.getItem("accessToken");
      const config = {headers: {"X-Authorization": `Bearer ${token}`}};
      let id= this.currAnimal;
      let self=this;
      if(this.fileU!=null){
        let formData=new FormData();
        formData.append('file', this.fileU);
        formData.append('name', this.filename);
        axios.post(this.$fileUpUrl, formData,
        {
          headers: {
            "X-Authorization": `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(result){
          console.log(result);
          
          self.animal.image_url='temp__'+result.data.filetoken+'/'+result.data.files.file.name;
          console.log('animal post');
          self.$http.post("edit/animals/"+id, self.animal, config).then(()=>{
            self.$swal({
              title: 'Actualización de Animal',
              text: 'Se actualizó animal de manera satisfactoria',
              type: 'success',
              icon:'success',
              showCancelButton: false,
              confirmButtonColor:'#5E8F23',
              showCloseButton: true,
              showLoaderOnConfirm: false  
            }).then(function(){
              self.$router.go(0);
            });
          }).catch(error => {
            console.log(error)
          });
        })
      }else{
          this.$http.post("edit/animals/"+id, this.animal, config).then(()=>{
            this.$swal({
              title: 'Actualización de Animal',
              text: 'Se actualizó animal de manera satisfactoria',
              type: 'success',
              icon:'success',
              showCancelButton: false,
              confirmButtonColor:'#5E8F23',
              showCloseButton: true,
              showLoaderOnConfirm: false  
            }).then(function(){
              this.$router.go(0);
            });
          }).catch(error => {
            console.log(error)
          });
        }
    },

    insertWheigning(){
      const token = localStorage.getItem("accessToken");
      const config = {headers: {"X-Authorization": `Bearer ${token}`}};
      let id= this.currAnimal;
      this.$http.post("add/weighins/"+id, this.weighins, config).then(()=>{
        this.weighins={
          observations:'',
          animal_id:this.currAmimal,
          weight:0,
          date:''
        },

        this.$swal({
          title: 'Pesaje',
          text: 'Se insertó el peso del animal de manera satisfactoria',
          type: 'success',
          icon:'success',
          showCancelButton: false,
          confirmButtonColor:'#5E8F23',
          showCloseButton: true,
          showLoaderOnConfirm: false  
        }).then(function(){


        });
      }).catch(error => {
        console.log(error)
      });
    },

    showModal(params){
      if(this.online){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        console.log(params.row.id);
        this.currAnimal=params.row.id;
        console.log('Current:'+this.currAnimal);
        this.fetchAnimalData(config)
        .then(()=>{
          return Promise.all([
          this.fetchAnimalWheihins(config),
          this.fetchAnimalVacinations(config),
          this.fetchAnimalDewormings(config),
          this.fetchAnimalTreathments(config),
          this.fetchChilds(config),
          this.fetchAnimalReproductive(config),
          this.fetchAnimalMilks(config)
          ]);
        })
        .then(() => {
          // Aquí puedes manejar cualquier lógica adicional después de que todos los fetchs se completen
          this.modalShow = true;
          this.modalCase = 0;
        })
        .catch(error => {
          console.error("Error fetching animal data:", error);
          // Manejo de errores si es necesario
        });
      }else{
        this.modalShow=true;
        this.modalCase=7;
      }
    },
    navigateTo(val){
      this.$router.push(val);
    },
    onConnectionChange(val){
      this.online=val;
      console.log(val);
    },
    exportCSV(){
      const myLogs = this.arrayToCsv(this.rowsExport);
      this.downloadBlob(myLogs, './animales_export.csv', 'text/csv;charset=utf-8,%EF%BB%BF;');
      console.log("Logs has been saved");
    },
    arrayToCsv(data) {
      const array = [Object.keys(data[0])].concat(data)

      return array.map(it => {
          return Object.values(it).toString()
      }).join('\n');
    },
    downloadBlob(content, filename, contentType) {
      // Create a blob
      var blob = new Blob([content], { type: contentType });
      var url = URL.createObjectURL(blob);

      // Create a link to download it
      var pom = document.createElement('a');
      pom.href = url;
      pom.setAttribute('download', filename);
      pom.click();
    },

    
  },
  
  watch:{
      'fileU':function(value){
        this.imgWidth=200;
        this.featured=URL.createObjectURL(this.fileU);
        console.log(value);
      },
  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
    this.online=navigator.onLine;
    this.fetchAnimals(config);
    this.fetchAnimalsExport(config);
    this.fetchStraws(config);
  },
 
}



</script>
<style lang="scss">
body {
  background-color: white !important;
}
table{
    width: 100% !important;
  }
  .vgt-responsive{
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; 
}
.subTitle {
  font-weight: 600;
  font-size: 23px;

}

.linkTitle {

  font-weight: 500;
  font-size: 14px;
  text-align: center;
  letter-spacing: 0.4px;
  color: #5E8F23;

}

.headTitle {
  font-weight: 600;
  font-size: 24px;
  color: #5E8F23;
}

thead{
  background-color: #5E8F23;
  text-align:center;
  color:#ffffff;
}
thead> tr{
  padding:5px;
}
.editAnimal {
  font-weight: 500;
  font-size: 18px;
}


.editModal {
  font-weight: 500;
  font-size: 18px;
}

span.text-center{
  display:flex;
  justify-content: center;
  text-align: center;
}

.footer__navigation__page-btn {
  background-color: #5e8f23; /* color de fondo */
  color: white; /* color del texto */
  border-radius: 4px;
  padding: 5px 10px;
  text-align:center;
}
.footer__row-count{
  margin-top:10px;
}
.footer__navigation, .vgt-pull-right{
  text-align:center!important;
  width:100%;
  display:grid;
  margin-top:10px;
}
</style>